import React, { useState, useEffect } from "react";
import AppShell from "../layouts/AppShell";
import { appModules } from "../components/global";
import { GET, POST, PUT, DELETE, loading, alert } from "../components/CustomComponent";

export default function Procurement() {
  const { title, description } = appModules["procurement"];
  const [data, setData] = useState([]);

  const summaryCards = [
    { label: "รายการขอซื้อใหม่ (PR)", value: "15", color: "#0c76e5" },
    { label: "รอการอนุมัติ", value: "7", color: "#e5a93e" },
    { label: "สั่งซื้อเสร็จสิ้น (PO)", value: "102", color: "#48bb78" },
  ];

  const GetData = async () => {
    loading(true);
    let body = {};
    let result = await GET("v1/admin/procurements", body);
    if (result?.status) {
      setData(result.data || []);
    }
    loading(false);
  };

  useEffect(() => {
    GetData();
  }, []);

  const CreateUpdate = async (formData) => {
    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let uid = formData?.uid;
      let body = { ...formData };

      let result = !uid
        ? await POST("v1/admin/procurements", body)
        : await PUT("v1/admin/procurements/" + uid, body);
        
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const DeleteData = async (id) => {
    if (
      await alert("", "warning", "ลบรายการ", "ต้องการลบรายการนี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let result = await DELETE("v1/admin/procurements/" + id, null);
      if (result?.status) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
      }
      loading(false);
    }
  };

  return (
    <AppShell title={title} description={description}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <div className="d-flex gap-2 filters-mobile-stack">
          <select className="form-select" style={{ width: '200px', borderRadius: '12px' }}>
            <option>สถานะ: รออนุมัติ</option>
            <option>สถานะ: ทั้งหมด</option>
          </select>
        </div>
        <button className="btn btn-primary px-4">
          สร้างคำขอจัดซื้อ (PR)
        </button>
      </div>

      <div className="row g-3 mb-4">
        {summaryCards.map((item) => (
          <div key={item.label} className="col-12 col-md-4">
            <div
              className="h-100 rounded-4 p-4 d-flex flex-column justify-content-center"
              style={{
                background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
                border: "1px solid rgba(18, 125, 255, 0.10)",
                boxShadow: "0 14px 28px rgba(12, 118, 229, 0.06)",
              }}
            >
              <p className="small text-uppercase text-secondary mb-1">{item.label}</p>
              <h2 className="h2 mb-0 fw-bold" style={{ color: item.color }}>{item.value}</h2>
            </div>
          </div>
        ))}
      </div>

      <div
        className="rounded-4 p-3 bg-white"
        style={{
          border: "1px solid rgba(18, 125, 255, 0.10)",
          boxShadow: "0 4px 12px rgba(12, 118, 229, 0.04)",
        }}
      >
        <h5 className="mb-4 fw-semibold text-dark">ติดตามคำขอจัดซื้อ</h5>
        <div className="table-responsive table-mobile-cards">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th className="text-secondary fw-medium rounded-start">เลขที่เอกสาร PR</th>
                <th className="text-secondary fw-medium">เรื่อง</th>
                <th className="text-secondary fw-medium">ผู้ขอ / แผนก</th>
                <th className="text-secondary fw-medium text-end">ประมาณการงบ (บาท)</th>
                <th className="text-secondary fw-medium text-center rounded-end">ตรวจสอบ</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3].map((i) => (
                <tr key={i}>
                  <td data-label="เลขที่เอกสาร PR">PR-2603-{String(10 + i).padStart(3, '0')}</td>
                  <td data-label="เรื่อง"><div className="fw-medium">ขออนุมัติซื้อจอ Monitor สำหรับทีม Dev</div></td>
                  <td data-label="ผู้ขอ / แผนก">คุณ สมชาย (IT)</td>
                  <td data-label="ประมาณการงบ (บาท)" className="text-end fw-bold">12,500.00</td>
                  <td data-label="ตรวจสอบ" className="text-center">
                    <button className="btn btn-sm btn-outline-primary rounded-3" title="ดูรายละเอียด"><i className="fa-solid fa-eye" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AppShell>
  );
}